import { render, staticRenderFns } from "./GetTokens.vue?vue&type=template&id=383ab317&"
import script from "./GetTokens.vue?vue&type=script&lang=js&"
export * from "./GetTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports